import { ICONS } from '.'

export const getIconFromString = (iconString: string) => {
  return ICONS.find((icon) => icon.name === iconString)?.icon
}